import { render, staticRenderFns } from "./DiscoverFiltersModal.vue?vue&type=template&id=ddd91646&scoped=true&"
import script from "./DiscoverFiltersModal.vue?vue&type=script&lang=ts&"
export * from "./DiscoverFiltersModal.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverFiltersModal.vue?vue&type=style&index=0&id=ddd91646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd91646",
  null
  
)

export default component.exports